import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginPageComponent } from '../login/login-page.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { ThirdPartyPageComponent } from './third-party/third-party-page.component';

export const authRoutes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'third-party', component: ThirdPartyPageComponent },
  { path: 'login', component: LoginPageComponent },
  { path: 'UserLink', component: PasswordResetComponent },
];

@NgModule({
  imports: [RouterModule.forChild(authRoutes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
